"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilteredCustomHeaders = exports.mutateMoneraService = exports.queryMoneraService = exports.shouldRetryOnNetworkError = void 0;
const config_1 = __importDefault(require("next/config"));
const constants_1 = require("../constants");
const csm_1 = require("../csm");
const isomorphic_1 = require("../isomorphic");
const models_1 = require("../models");
const error_1 = require("../models/error");
const auth_1 = require("../utils/auth");
const config_2 = require("../utils/config");
const http_1 = require("../utils/http");
const metric_helper_1 = require("../utils/metric-helper");
const share_1 = require("../utils/share");
const window_1 = require("../utils/window");
const apollo_client_1 = require("./apollo-client");
const schema_1 = require("./schema");
const shouldRetryOnNetworkError = (error, operation) => {
    const operationName = operation.operationName;
    if (error && error.statusCode >= 500 && error.statusCode < 600) {
        isomorphic_1.LOGGER.warn('Retrying 5XX', { error, operationName });
        return true;
    }
    else if (error && error.code && error.code.startsWith('ECONN')) {
        isomorphic_1.LOGGER.warn('Retrying network error', { error, operationName });
        return true;
    }
    else if (error && error.statusCode === 307) {
        return false;
    }
    else {
        isomorphic_1.LOGGER.warn('Not Retrying network error', { error, operationName });
        return false;
    }
};
exports.shouldRetryOnNetworkError = shouldRetryOnNetworkError;
const redirectResponse = (error) => {
    const locationValue = error.networkError.response.headers.get('Location');
    const locationUrl = new URL(locationValue);
    return {
        data: error,
        name: error_1.ErrorType.SHOPPING_PORTAL_REDIRECT_ERROR,
        message: "Append tenantId to MA's endpoint url and redirect to Shopping Portal",
        tenantId: locationUrl.searchParams.get('tenantId')
    };
};
const clientSideNetworkErrorResponse = (error, methodName, tenantId) => {
    var _a;
    const statusCode = (_a = error.networkError) === null || _a === void 0 ? void 0 : _a.statusCode;
    const metricName = `StatusCode:${statusCode}`;
    (0, metric_helper_1.emitCountMetrics)(methodName, metricName, 1, '', tenantId);
    const errorType = (0, window_1.isClientSide)() ? error_1.ErrorType.CLIENT_SIDE_NETWORK_ERROR : error_1.ErrorType.UNEXPECTED_ERROR;
    const errorMsg = `${(0, window_1.isClientSide)() ? '400 Error: Client side Network Error' : '500 Error: Internal Service Error'}: Received Status Code ${statusCode}`;
    isomorphic_1.LOGGER.warn(errorMsg);
    return {
        data: error,
        name: errorType,
        message: errorMsg
    };
};
const shouldEmitCsmMetric = (props) => {
    return (0, window_1.isClientSide)() && !props.isPartialPageRequest;
};
const isInvalidHttpHeaderValue = (value) => {
    isomorphic_1.LOGGER.debug(`Sanitizing ${value}`);
    const invalidHeaderCharRegex = /[^\t\x20-\x7e\x80-\xff]/;
    if (invalidHeaderCharRegex.test(value)) {
        isomorphic_1.LOGGER.error(`Detected invalid http header character in ${value}`);
        return true;
    }
    return false;
};
const queryMoneraService = (props) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { gqlQuery, variables, headers = {}, callbackFn } = props;
    const configState = (0, config_2.retrieveConfigState)(headers);
    const isMock = (0, config_1.default)().publicRuntimeConfig.isMock;
    const moneraServiceGraphQlUrl = configState.moneraServiceGraphQlUrl;
    const apolloClient = isMock
        ? (0, apollo_client_1.getApolloClient)(moneraServiceGraphQlUrl, false, undefined, undefined, schema_1.mockTypeDefs, (0, schema_1.getMockResolvers)(), true)
        : (0, apollo_client_1.getApolloClient)(moneraServiceGraphQlUrl, true, undefined, undefined, undefined, undefined, false, constants_1.ENV_STAGE !== 'local');
    if (isMock) {
        isomorphic_1.LOGGER.info('Making mocked query');
    }
    else {
        isomorphic_1.LOGGER.info(`Making query to MoneraService via URL: ${moneraServiceGraphQlUrl} with header adgwdg: ${configState.adgwdg}, templateType: ${configState.templateType} `);
    }
    const adgwdgHeader = configState.adgwdg ? { [http_1.HTTPHeaders.Adgwdg]: configState.adgwdg } : {};
    if (isInvalidHttpHeaderValue(configState.templateType)) {
        return {
            message: 'Bad input value for templateType!',
            name: error_1.ErrorType.INVALID_INPUT_ERROR
        };
    }
    const templateType = configState.templateType ? { [http_1.HTTPHeaders.MoneraTemplateType]: configState.templateType } : {};
    const moneraAppQuery = configState.moneraAppQuery ? { [http_1.HTTPHeaders.MoneraAppQuery]: configState.moneraAppQuery } : {};
    const ref = configState.ref ? { [http_1.HTTPHeaders.ref]: configState.ref } : {};
    const moneraAppOriginalUri = configState.moneraAppOriginalUri
        ? { [http_1.HTTPHeaders.MoneraAppOriginalUri]: configState.moneraAppOriginalUri }
        : {};
    let ajaxReqId = '';
    let overrideRequestIdHeaders = {};
    if (shouldEmitCsmMetric(props)) {
        ajaxReqId = (0, share_1.generateRequestId)();
        csm_1.csm.markAjaxStartRequest();
        overrideRequestIdHeaders = {
            [http_1.HTTPHeaders.OriginalRequestId]: (0, config_2.getRequestId)(headers),
            [models_1.ShoppingPortalHeadersEnum.RequestId]: ajaxReqId
        };
    }
    const updatedHeaders = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, templateType), headers), adgwdgHeader), moneraAppQuery), ref), moneraAppOriginalUri), overrideRequestIdHeaders);
    const result = yield apolloClient
        .query({
        query: gqlQuery,
        variables: Object.assign(Object.assign({}, variables), { customHeaders: (0, exports.getFilteredCustomHeaders)(Object.assign(Object.assign({}, updatedHeaders), ((_a = variables === null || variables === void 0 ? void 0 : variables.customHeaders) !== null && _a !== void 0 ? _a : {}))) }),
        context: {
            headers: updatedHeaders
        }
    })
        .then((value) => {
        isomorphic_1.LOGGER.info('Successful query');
        return value;
    })
        .catch((error) => {
        var _a, _b, _c;
        if (((_a = error.networkError) === null || _a === void 0 ? void 0 : _a.statusCode) === 307) {
            isomorphic_1.LOGGER.info('Redirecting to different tenant for a GQL query with variables', variables);
            return redirectResponse(error);
        }
        isomorphic_1.LOGGER.error(`Error when making query with variables ${JSON.stringify(variables)}: something ${JSON.stringify(error)}`);
        const statusCodePrefix = String((_b = error.networkError) === null || _b === void 0 ? void 0 : _b.statusCode).charAt(0);
        if (statusCodePrefix === '4') {
            return clientSideNetworkErrorResponse(error, 'QueryMoneraService', configState.tenantId);
        }
        isomorphic_1.LOGGER.info(`Creating Error from createFromApolloError` + ((_c = error.networkError) === null || _c === void 0 ? void 0 : _c.statusCode));
        return (0, error_1.createFromApolloError)(error);
    })
        .finally(() => {
        if (shouldEmitCsmMetric(props)) {
            csm_1.csm.markAjaxResponseReceived(ajaxReqId);
        }
    });
    if (callbackFn) {
        callbackFn();
    }
    return result;
});
exports.queryMoneraService = queryMoneraService;
const mutateMoneraService = (props) => __awaiter(void 0, void 0, void 0, function* () {
    var _b;
    const { gqlMutation, variables, headers = {}, callbackFn, shouldRedirectUnauthenticatedToAuthPortal = true } = props;
    const configState = (0, config_2.retrieveConfigState)(headers);
    const isMock = (0, config_1.default)().publicRuntimeConfig.isMock;
    const moneraServiceGraphQlUrl = configState.moneraServiceGraphQlUrl;
    const apolloClient = isMock
        ? (0, apollo_client_1.getApolloClient)(moneraServiceGraphQlUrl, false, undefined, undefined, schema_1.mockTypeDefs, (0, schema_1.getMockResolvers)(), true)
        : (0, apollo_client_1.getApolloClient)(moneraServiceGraphQlUrl, false);
    if (isMock) {
        isomorphic_1.LOGGER.info('Making mocked mutation');
    }
    else {
        isomorphic_1.LOGGER.info(`Making mutation to MoneraService via URL: ${moneraServiceGraphQlUrl} with header adgwdg: ${configState.adgwdg}`);
    }
    const adgwdgHeader = configState.adgwdg ? { [http_1.HTTPHeaders.Adgwdg]: configState.adgwdg } : {};
    const moneraAppQuery = configState.moneraAppQuery ? { [http_1.HTTPHeaders.MoneraAppQuery]: configState.moneraAppQuery } : {};
    const ref = configState.ref ? { [http_1.HTTPHeaders.ref]: configState.ref } : {};
    const moneraAppOriginalUri = configState.moneraAppOriginalUri
        ? { [http_1.HTTPHeaders.MoneraAppOriginalUri]: configState.moneraAppOriginalUri }
        : {};
    const countryCode = configState.countryCode;
    const requestIdHeader = {
        [http_1.HTTPHeaders.RequestId]: (0, share_1.generateRequestId)(),
        [http_1.HTTPHeaders.OriginalRequestId]: (0, config_2.getRequestId)(headers)
    };
    const updatedHeaders = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, headers), adgwdgHeader), requestIdHeader), moneraAppQuery), ref), moneraAppOriginalUri);
    const result = yield apolloClient
        .mutate({
        mutation: gqlMutation,
        variables: Object.assign(Object.assign({}, variables), { customHeaders: (0, exports.getFilteredCustomHeaders)(Object.assign(Object.assign({}, updatedHeaders), ((_b = variables === null || variables === void 0 ? void 0 : variables.customHeaders) !== null && _b !== void 0 ? _b : {}))) }),
        context: {
            headers: updatedHeaders
        }
    })
        .catch((error) => {
        var _a;
        isomorphic_1.LOGGER.error(`Error when making mutation with variables ${JSON.stringify(variables)}: ${JSON.stringify(error)}`);
        const statusCodePrefix = String((_a = error.networkError) === null || _a === void 0 ? void 0 : _a.statusCode).charAt(0);
        if (statusCodePrefix === '4') {
            return clientSideNetworkErrorResponse(error, 'MutateMoneraService', configState.tenantId);
        }
        return (0, error_1.createFromApolloError)(error);
    });
    if (callbackFn) {
        callbackFn(result);
    }
    if (shouldRedirectUnauthenticatedToAuthPortal && (0, error_1.isError)(result)) {
        handleAuthenticationError(result, countryCode);
    }
    return result;
});
exports.mutateMoneraService = mutateMoneraService;
const handleAuthenticationError = (apolloError, countryCode) => {
    if (apolloError.name === error_1.ErrorType.AUTHENTICATION_FAILED_ERROR) {
        (0, auth_1.redirectToAuthPortalV2)(countryCode, true);
    }
};
const getFilteredCustomHeaders = (customHeaders) => {
    if (!customHeaders) {
        return {};
    }
    const prefixes = ['x-amz-', 'x-amzn-', 'x-amazon-'];
    const filteredHeaders = {};
    Object.keys(customHeaders).forEach((key) => {
        if (!prefixes.some((prefix) => key.toLocaleLowerCase().startsWith(prefix))) {
            filteredHeaders[key.toLocaleLowerCase()] = customHeaders[key];
        }
    });
    return filteredHeaders;
};
exports.getFilteredCustomHeaders = getFilteredCustomHeaders;
